function checkFiels(obJectToCheck) {
  let answer = true;
  for (let key in obJectToCheck) {
    if (!obJectToCheck[key]) {
      answer = false;
    }
  }
  return answer;
}

/**
 * Calculate the reduction percentage between two prises
 * @param {number} prise
 * @param {number} oldPrise
 * @returns
 */
function percentageReduction(prise, oldPrise) {
  return Math.round(((prise - oldPrise) / oldPrise) * 100);
}

export { checkFiels, percentageReduction };
